import { Grid } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { AsyncSelect, ControlledDatePicker } from "src/components/forms";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { OperacionCLGFields } from "../types/fields";
import { FormNuevaOperacionCLG, FormOperacionCLG, OperacionCLG } from "../types/types";
import { dateFormatter } from "src/utils/formatters";
import {SectorComercialFields} from "../../../../../types";
import {SistemaTipo} from "../../../../../types/enum/enum";
import {useSectoresComerciales} from "../../../../messages/api/useSectoresComerciales";
import {useLoadOptions} from "../../../../../hooks/useLoadOptions";

type DatosOperacionProps = {
    codSistemaPrincipal: number,
    codSistema: number,
    formMethods: UseFormReturn<FormOperacionCLG> | UseFormReturn<FormNuevaOperacionCLG>,
    readOnly?: boolean
    operacion?: OperacionCLG
    nuevo?: boolean
}

const SeccionCLGDatosOperacion = ({ codSistemaPrincipal, codSistema, formMethods, readOnly, operacion, nuevo }: DatosOperacionProps) => {
    const { control, watch } = formMethods

    const sectoresHook = useSectoresComerciales(codSistema)

    const loadSectoresComerciales = useLoadOptions({
        data: sectoresHook.sectores,
        loading: sectoresHook.loading,
        isError: sectoresHook.isError,
        error: sectoresHook.error
    });

    return (
        <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
            <SectionBox>
                {!nuevo && (
                    <Grid item xs={12} md={3}>
                        <FieldView
                            label='Usuario Alta'
                            value={operacion ? `${operacion.nombreUsuarioAlta} ${operacion.apellidoUsuarioAlta}` : undefined}
                        />
                    </Grid>
                )}
                <Grid item xs={12} md={3}>
                    {readOnly ? (
                        <FieldView
                            label='Fecha Aprobación'
                            value={operacion ? dateFormatter.toShortDate(operacion?.fechaAprobacion) : undefined}
                        />
                    ) : (
                        <ControlledDatePicker
                            name={OperacionCLGFields.FechaAprobacion}
                            label='Fecha Aprobación'
                            control={control}
                            selectedSections={undefined}
                            onSelectedSectionsChange={console.log}
                            fullWidth
                            readOnly={readOnly}
                        />
                    )}
                </Grid>
                <Grid item xs={12} md={3}>
                    {readOnly ? (
                        <FieldView
                            label='Fecha Vencimiento'
                            value={(operacion && operacion?.fechaVencimiento) ? dateFormatter.toShortDate(operacion?.fechaVencimiento) : undefined}
                        />
                    ) : (
                        <ControlledDatePicker
                            name={OperacionCLGFields.FechaVencimiento}
                            label='Fecha Vencimiento'
                            control={control}
                            selectedSections={undefined}
                            onSelectedSectionsChange={console.log}
                            fullWidth
                            minDate={(watch as (fieldName: string) => any)(OperacionCLGFields.FechaAprobacion)}
                            readOnly={readOnly}
                        />
                    )}
                </Grid>
                <Grid item xs={12} md={3}>
                    {readOnly ? (
                        <FieldView
                            label='Sector Comercial'
                            value={operacion?.nombreSectorComercial}
                        />
                    ) : (
                        <AsyncSelect
                            control={control}
                            name={OperacionCLGFields.CodInstitutionalSales}
                            label='Sector Comercial'
                            loadOptions={loadSectoresComerciales}
                            valueField={SectorComercialFields.SectorComercialCodigo}
                            fullWidth
                            InputProps={{
                                readOnly: readOnly
                            }}
                        />
                    )}
                </Grid>
            </SectionBox>
        </CardActions>
    )
}

export default SeccionCLGDatosOperacion
